import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {
  BottomRow,
  H4Styled,
  Img,
  LinkStyled,
  MealCardStyled,
  MealCardTextWrapper,
  P,
  PriceStyled
} from './GalleryPage.style';
import {Price} from '../../components/Price/Price';

const GalleryMealCard = ({meal}) => {
  return (
    <MealCardStyled data-rw="gallery-page--mealcard">
      <Img
        src={meal.primaryImageUrl}
        alt={meal.name}
        data-rw="gallery-page--mealcard--image"
      />
      <MealCardTextWrapper>
        <div>
          <H4Styled data-rw="gallery-page--mealcard-name">{meal.name}</H4Styled>
          <P data-rw="gallery-page--mealcard--description">{meal.description}</P>
        </div>
        <BottomRow>
          <PriceStyled data-rw="gallery-page--mealcard--price">
            <Price amount={meal.price} />
          </PriceStyled>
          <LinkStyled
            to={{ pathname: '/menu', search: `?mealUuid=${meal.uuid}` }}
            data-rw="gallery-page--mealcard--order-now-button"
          >
            <FormattedMessage
              id="gallery.orderNow"
            />
          </LinkStyled>
        </BottomRow>
      </MealCardTextWrapper>
    </MealCardStyled>
  );
};

GalleryMealCard.propTypes = {
  meal: PropTypes.object.isRequired
};

export default GalleryMealCard;



// WEBPACK FOOTER //
// ./containers/GalleryPage/GalleryMealCard.js